export type HotRankItem = {
  title: string;
  heat: number;
  delta: number;
  tag: string;
  category: string;
};

export const tickerItems: string[] = [
  "「年度音乐盛典」官宣名单冲上榜首",
  "夜宵经济回暖 多城烟火气回归",
  "新一代轻薄本实测续航翻倍刷屏",
  "大学生'夜校'抢课成新潮流",
  "多城围炉煮茶冬日场景走红",
  "旅行团综艺再出全新'名场面'",
  "智能手环健康提醒功能火出圈",
  "体育大年 全民健身话题升温",
];

export const hotSearch: HotRankItem[] = [
  { title: "「年度音乐盛典」正式官宣嘉宾名单", heat: 982, delta: 1, tag: "娱乐瓜", category: "娱乐" },
  { title: "高校毕业照'创意穿搭'登顶热搜", heat: 945, delta: 3, tag: "青春热点", category: "校园" },
  { title: "多城市'夜宵地图'刷屏社交平台", heat: 911, delta: 0, tag: "社会热点", category: "社会" },
  { title: "旅行团综又爆'名场面'全网热议", heat: 878, delta: -1, tag: "综艺", category: "娱乐" },
  { title: "新一代轻薄本实测续航翻倍引关注", heat: 846, delta: 5, tag: "科技热闻", category: "科技" },
  { title: "年轻人爱上'夜校' 课程一票难求", heat: 815, delta: 2, tag: "生活潮流", category: "生活" },
  { title: "围炉煮茶成冬日社交'新仪式'", heat: 782, delta: -2, tag: "生活潮流", category: "生活" },
  { title: "国产动漫剧场版预售开启引期待", heat: 754, delta: 4, tag: "二次元", category: "文娱" },
  { title: "全民健身热潮带动体育用品热销", heat: 723, delta: -3, tag: "民生热议", category: "民生" },
  { title: "智能手环健康提醒功能为何走红", heat: 695, delta: -1, tag: "数码圈", category: "科技" },
];

export type EventItem = {
  title: string;
  summary: string;
  heat: number;
  tag: string;
  time: string;
};

export const events: EventItem[] = [
  {
    title: "年度音乐盛典嘉宾阵容官宣",
    summary: "组委会一次性公布本届盛典首发嘉宾名单，多组首次同台的搭档引爆期待，相关话题阅读量数小时破亿。",
    heat: 982,
    tag: "娱乐大瓜",
    time: "10 分钟前",
  },
  {
    title: "毕业季'创意拍照'出圈",
    summary: "多所高校学生用脑洞十足的穿搭与构图记录毕业时刻，被网友称为'青春该有的样子'。",
    heat: 945,
    tag: "青春热点",
    time: "26 分钟前",
  },
  {
    title: "夜宵经济带动城市烟火气",
    summary: "多地商圈延长营业、夜市人气回升，'夜宵地图'成为年轻人下班后社交的新注脚。",
    heat: 911,
    tag: "社会热点",
    time: "41 分钟前",
  },
  {
    title: "新一代轻薄本实测续航翻倍",
    summary: "博主实测新款轻薄本在办公场景下续航显著提升，能效表现让不少'通勤党'直呼想换机。",
    heat: 846,
    tag: "科技热闻",
    time: "1 小时前",
  },
  {
    title: "『夜校』抢课潮席卷年轻群体",
    summary: "舞蹈、烘焙、非遗手作等实用又有趣的夜校课程上线即约满，被称为新型'下班生活指南'。",
    heat: 815,
    tag: "生活潮流",
    time: "1 小时前",
  },
  {
    title: "国产动漫剧场版开启预售",
    summary: "多部话题动画电影同步开启预售与点映，粉丝热情高涨，相关衍生话题持续升温。",
    heat: 754,
    tag: "文娱圈",
    time: "2 小时前",
  },
];

export type CategoryItem = {
  name: string;
  icon: string;
  count: number;
  blurb: string;
  top: string;
  tone: "primary" | "accent" | "secondary";
};

export const categories: CategoryItem[] = [
  { name: "娱乐瓜", icon: "ri-star-smile-line", count: 128, blurb: "影视综艺、明星动态与文娱大事件", top: "盛典官宣登顶", tone: "primary" },
  { name: "社会热点", icon: "ri-building-2-line", count: 96, blurb: "民生动态、城市话题与公共议题", top: "夜宵地图刷屏", tone: "accent" },
  { name: "科技热闻", icon: "ri-cpu-line", count: 74, blurb: "数码新品、硬核评测与技术前沿", top: "轻薄本续航实测", tone: "secondary" },
  { name: "生活潮流", icon: "ri-sparkling-2-line", count: 88, blurb: "生活方式、兴趣社交与流行趋势", top: "夜校抢课火爆", tone: "accent" },
  { name: "校园青春", icon: "ri-graduation-cap-line", count: 51, blurb: "毕业季、创意与年轻人的故事", top: "毕业照出圈", tone: "primary" },
  { name: "民生热议", icon: "ri-leaf-line", count: 66, blurb: "民生议题与日常关切", top: "全民健身升温", tone: "secondary" },
];

export type TopicCover = {
  kicker: string;
  title: string;
  summary: string;
  time: string;
  reads: string;
  img: string;
  alt: string;
};

export const topicCovers: TopicCover[] = [
  {
    kicker: "今日大瓜 · 娱乐",
    title: "盛典官宣背后的'顶流'排位战",
    summary: "从首发阵容到同台搭档，每一处细节都被网友反复解读。这份名单背后，藏着行业热度与话题运营的完整逻辑。",
    time: "10 分钟前",
    reads: "126 万阅读",
    img: "https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20music%20awards%20ceremony%20stage%20with%20spotlight%20and%20confetti%2C%20microphone%20and%20trophy%2C%20warm%20fire%20orange%20and%20watermelon%20green%20accent%20on%20cream%20paper%20background%2C%20playful%20modern%20minimal%20collage%20style%2C%20high%20detail%20clean%20composition&width=1200&height=720&seq=cover-awards-2026-x1&orientation=landscape",
    alt: "音乐盛典舞台聚光灯与彩带插画，年度盛典娱乐热点解析",
  },
  {
    kicker: "社会观察",
    title: "夜宵经济回暖，城市的烟火气回来了",
    summary: "延长营业的商圈、排队的小摊与一张张夜宵地图，正在成为衡量一座城市活力的新标尺。我们盘点了近期最出圈的城市夜场景。",
    time: "41 分钟前",
    reads: "88 万阅读",
    img: "https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20cozy%20night%20street%20food%20market%20with%20stalls%20and%20warm%20lanterns%2C%20steaming%20food%20and%20city%20skyline%2C%20fire%20orange%20and%20watermelon%20green%20palette%20on%20cream%20paper%2C%20playful%20modern%20minimal%20collage%2C%20clean%20composition&width=1200&height=720&seq=cover-nightmarket-2026-x1&orientation=landscape",
    alt: "夜晚街边小吃摊与暖色灯笼插画，城市夜宵经济热点解析",
  },
  {
    kicker: "科技热闻",
    title: "续航翻倍？轻薄本的'能效竞赛'",
    summary: "实测数据的背后是芯片制程与系统调优的合力。对普通通勤用户来说，一次升级到底能省下多少'电量焦虑'？",
    time: "1 小时前",
    reads: "63 万阅读",
    img: "https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20slim%20laptop%20with%20a%20battery%20icon%20and%20charging%20bolt%2C%20floating%20tech%20elements%20and%20circuit%20motifs%2C%20watermelon%20green%20and%20fire%20orange%20accent%20on%20cream%20paper%2C%20playful%20modern%20minimal%20collage%2C%20clean%20composition&width=1200&height=720&seq=cover-laptop-2026-x1&orientation=landscape",
    alt: "轻薄本与电量图标插画，笔记本电脑续航科技热点解析",
  },
];

export const miniTopics = [
  { tag: "综艺", title: "旅行团综又出'名场面'，笑点与泪点齐飞", reads: "42 万阅读" },
  { tag: "生活", title: "围炉煮茶：年轻人的冬日'慢社交'", reads: "37 万阅读" },
  { tag: "数码", title: "智能手环的健康提醒，为何越用越上头", reads: "29 万阅读" },
  { tag: "校园", title: "大学生'夜校'抢课攻略：如何一击即中", reads: "31 万阅读" },
];

export const faqs = [
  {
    q: "吃瓜热门多久更新一次？",
    a: "热搜榜与事件排行会随全网讨论热度实时刷新，页面采用轻量自动刷新机制，无需手动翻找，重新进入或切到时间视图即可看到最新动态。",
  },
  {
    q: "排行榜的热度是怎么算出来的？",
    a: "排行综合了全网多个平台的搜索量、讨论量与传播热度，通过统一算法归一化后形成热度值。你可以在'热度/时间'两种视图间切换，分别查看当下最火与最新发酵的话题。",
  },
  {
    q: "想找一个具体的热点或老瓜，该从哪里入手？",
    a: "可以先用首屏搜索框直接输入关键词，也可以进入对应的分类热榜（娱乐、社会、科技、生活等）按话题浏览，事件排行还会给出每个事件的梗概与热度曲线参考。",
  },
  {
    q: "我发现了有意思的新鲜事，可以投稿吗？",
    a: "当然可以。欢迎通过页面底部的联系入口提供线索，编辑团队核实后会结合数据热度评估是否上榜，并标注信息来源，让更多同好一起吃到瓜。",
  },
  {
    q: "内容会保证真实和客观吗？",
    a: "我们只展示可公开讨论的公开信息与网络热点，并尽量保留原始语境。榜单仅反映热度排行，不代表立场倾向；对尚在演变的事件会持续跟新说明，力求客观不传谣。",
  },
];

export const brandStats = [
  { value: "1200+", label: "每日监测热点" },
  { value: "60+", label: "覆盖资讯源" },
  { value: "6 大类", label: "兴趣分类热榜" },
  { value: "10 秒", label: "极速刷新" },
];